import Modal from 'Site/component/Modal.vue';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapState } from 'vuex';
import AlbumInvite from '../../component/AlbumInvite.vue';

export default function () {
    new Vue({ /* eslint no-new: 0 */
        el: '#page-header',
        name: 'AlbumInvitesPage',
        store,
        components: {
            AlbumInvite,
            Modal
        },
        computed: mapState(['t']),
        data: {
            showInviteModal: false
        }
    });
}
